module.exports = __webpack_public_path__ + "img/ch-executive-summary.5ea41526.jpg";